<template>
  <van-popup
    class="game-plat-popup"
    v-model="popupShow"
    round
    position="bottom"
  >
    <div class="popup-box">
      <img
        class="discount-icon"
        src="@/assets/images/ic_apply_discount_1.png"
        alt=""
        v-show="discountShow"
        @click="applyForDiscount"
      />
      <div class="plat-title">
        <div class="plat-title-info">
          <img src="@/assets/images/ic_common_one.png" alt="" />
          <h1>选择{{ chosetypeMaps[btnType] }}平台</h1>
        </div>
        <div class="plat-title-desc" @click="descHandle">
          <span>{{ userInfo.vipLevel >= 1 ? "代金券说明" : "新手引导" }}</span>
          <img src="@/assets/images/ic_right_arrow_orange.png" alt="" />
        </div>
      </div>
      <div class="game-list-card" v-if="isGame">
        <div class="game-card-item" v-for="(item, i) in gameList" :key="i">
          <div class="game-plat-left">
            <div class="game-palt">
              <img :src="item.platLogo" alt="" />
              <span>{{ item.platName }}</span>
            </div>
            <div class="game-discount">
              <h1>{{ item.gameName }}</h1>
              <div class="recharge-discount">
                <span
                  >{{ item.rechargeFristName
                  }}{{ item.rechargeFristDiscount }}</span
                >
                <span
                  >{{ item.rechargeContinueName
                  }}{{ item.rechargeContinueDiscount }}</span
                >
              </div>
              <div class="recharge-tips" v-if="item.contactCustomer == 1">
                <span >注册账号请联系客服</span>
              </div>
              <div v-else class="recharge-tips">
                <span v-show="item.waterMark == 1" @click="discountDialog"
                  >专属折扣，请勿外传</span
                >
                <span
                  @click="firstDiscountDialog"
                  v-show="item.firstRechargeAudit == 1"
                  >首充审核</span
                >
                
              </div>
            </div>
          </div>
          <div class="game-btn">
            <span v-if="btnType == '00'" @click="goToRecharge(item)">充值</span>
            <span v-else @click="goToDownload(item)">下载</span>
          </div>
          <WatermarkBox
            class="water-mark"
            :id1="item.gameId"
            :id2="item.rechargeGameId"
          />
        </div>

        <div v-show="discountShow" class="tips-10">
          提示：10折游戏，找客服开内部折扣；0.1折上折；
        </div>
      </div>
      <van-loading size="24px" v-if="isLoading" vertical></van-loading>
      <div v-if="!isLoading && !isGame" class="game-empty">
        暂未iOS资源，请联系客服获取！
      </div>
    </div>
    <rechargeGuideDialog
      v-if="rechargeGuideDialogVisible"
      v-model="rechargeGuideDialogVisible"
    />
    <voucherDescDialog
      v-if="voucherDescDialogVisible"
      v-model="voucherDescDialogVisible"
    />
    <customerDialog
      v-if="customerDialogVisible"
      v-model="customerDialogVisible"
      @handleClose="dialogClose"
    />


    <promptPopup v-if="promptPopupVirsble" v-model="promptPopupVirsble" />
    <promptPopup2 v-if="promptPopup2Virsble" v-model="promptPopup2Virsble" />
  </van-popup>
</template>

<script>
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
import rechargeGuideDialog from "./RechargeGuideDialog";
import voucherDescDialog from "./VoucherDescDialog";
import customerDialog from "./CustomerDialog";
import WatermarkBox from "./WaterMark.vue";
import promptPopup from "@/components/PromptPopup";
import promptPopup2 from "@/components/PromptPopup2";
import platform from "../mixin/platform";

export default {
  mixins: [platform],
  components: {
    rechargeGuideDialog,
    voucherDescDialog,
    customerDialog,
    WatermarkBox,
    promptPopup,
    promptPopup2,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    btnType: {
      type: String,
      default: "",
    },
    gameInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(["uuid", "userInfo", "isLogin"]),
    discountShow() {
      let gameIdIndex = this.gameList.findIndex(
        (e) => e.rechargeGameId == e.gameId
      );
      let discountIndex = this.gameList.findIndex(
        (e) =>
          e.rechargeFristDiscount == "10折" &&
          e.rechargeContinueDiscount == "10折"
      );
      if (gameIdIndex != -1 && discountIndex != -1) {
        return true;
      } else {
        return false;
      }
    },
    popupShow: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },

    isGame() {
      return this.gameList.length;
    },
  },
  data() {
    return {
      chosetypeMaps: {
        "00": "充值",
        "01": "下载",
      },
      gameList: [],
      isLoading: true,
      rechargeGuideDialogVisible: false,
      voucherDescDialogVisible: false,
      customerDialogVisible: false,
      promptPopupVirsble: false,
      promptPopup2Virsble: false,
    };
  },
  created() {
    this.getGameByName();
  },
  methods: {
    dialogClose(action, done) {
      done();
    },
    // 能否申请折扣
    
    async checkCanApplyDiscount() {
      try {
        const { isCanApply } = await requestMethods("/modules/web/game/checkCanApplyDiscount.htm", "post", {
          uuid: this.uuid,
          gameId: this.gameInfo.gameId,
        });
        return {
          isCanApply: isCanApply
        }
      } catch (err) {
        // 通过 err.message 获取到错误信息
        this.$toast(err.message);
      }
    },
    /**
     * 申请折扣
     */
    async applyForDiscount() {
      const { isCanApply } = await this.checkCanApplyDiscount()
      if(isCanApply) {
        try {
          await requestMethods("modules/web/game/applyVipDiscount.htm", "post", {
            uuid: this.uuid,
            gameId: this.gameInfo.gameId,
          });
          this.$toast("申请成功");
          this.getGameByName();
        } catch (err) {
          // 通过 err.message 获取到错误信息
          this.$toast(err.message);
        }
      } else {
        this.customerDialogVisible = true
      }
      
    },
    
    /**
     * 充值游戏弹窗列表
     */
    async getGameByName() {
      try {
        const { data } = await requestMethods(
          "/modules/web/game/getGameByName.htm",
          "post",
          {
            uuid: this.uuid,
            appType: "WM",
            systemType: "IOS",
            gameName: this.gameInfo.gameName,
          }
        );
        this.gameList =
          data.chargeGameInfoList.map((e) => {
            return {
              ...e,
              rechargeGameId: this.gameInfo.gameId,
            };
          }) || [];
        console.log(this.gameList, "gameList---");
        this.isLoading = false;
      } catch (err) {
        // 通过 err.message 获取到错误信息
        this.$toast(err.message);
      }
    },

    discountDialog() {
      this.dialogText =
        "VIP折扣仅<em style='font-weight: 600'>部分玩家</em>可见，其余用户按原价充值；<br/>此页面请勿外传，否则将失去<em style='font-weight: 600'>所有游戏</em>的折扣特权；";
      this.$dialog.confirm({
        title: "温馨提示",
        width: "260px",
        message: this.dialogText,
        confirmButtonColor: "#FF7A3E",
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        confirmButtonText: "确定",
        messageAlign: "left",
      });
    },
    firstDiscountDialog() {
      this.dialogText =
        "<em style='font-weight: 600'>首充</em>请下单后立即联系客服；<br/><em style='font-weight: 600'>首充</em>需客服审核后到账，<em style='font-weight: 600'>续充</em>即时到账；";
      this.$dialog.confirm({
        title: "温馨提示",
        width: "260px",
        message: this.dialogText,
        confirmButtonColor: "#FF7A3E",
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        confirmButtonText: "确定",
        messageAlign: "left",
      });
    },

    goToDownload(info) {
      
      if (this.platformInfo.deviceType == "android") {
        window.location.href = "http://wmsy666.com/H5Android";
        return
      } else if (this.platformInfo.deviceType == "harmony") {
        window.open(info.h5Url);
        return
      } else if (
        this.platformInfo.deviceType == "ios" &&
        this.platformInfo.browserType != "safari"
      ) {
        this.promptPopupVirsble = true;
        return
      } else if (
        this.platformInfo.deviceType == "ios" &&
        this.platformInfo.browserType == "safari" &&
        !this.platformInfo.isBookmark
      ) {
        this.promptPopup2Virsble = true;
        return
      }
      
      window.open(info.h5Url);
    },
    /**
     * 充值
     */
    goToRecharge(info) {
      
      if (this.platformInfo.deviceType == "android") {
        window.location.href = "http://wmsy666.com/H5Android";
        return
      }  else if (
        this.platformInfo.deviceType == "ios" &&
        this.platformInfo.browserType != "safari"
      ) {
        this.promptPopupVirsble = true;
        return
      } else if (
        this.platformInfo.deviceType == "ios" &&
        this.platformInfo.browserType == "safari" &&
        !this.platformInfo.isBookmark
      ) {
        this.promptPopup2Virsble = true;
        return
      }
      
      if (info.control == 1) {
        this.dialogText =
          "该游戏严禁宣传折扣，为保障正常游戏，请勿向任何人透露折扣！";
        this.$dialog.confirm({
          title: "温馨提示",
          width: "260px",
          message: this.dialogText,
          confirmButtonColor: "#FF7A3E",
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          confirmButtonText: "我知道了",
          messageAlign: "left",
        });
      }
      const {
        logoUrl,
        gameName,
        gameId,
        discount,
        platName,
        platLogo,
        rechargeGameId,
      } = info;
      this.$router.push({
        path: "/recharge",
        query: {
          logoUrl,
          gameName,
          gameId,
          discount,
          platName,
          platUrl: platLogo,
          rechargeGameId,
        },
      });
      this.popupShow = false;
    },

    descHandle() {
      if (this.userInfo.vipLevel < 1) {
        this.rechargeGuideDialogVisible = true;
      } else {
        this.voucherDescDialogVisible = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.game-plat-popup {
  overflow: visible; /* 允许内容超出 */
}
.popup-box {
  padding: 30px;
  margin-bottom: 30px;
  position: relative;

  .discount-icon {
    width: 300px;
    height: 150px;
    position: absolute;
    left: 0;
    top: -150px;
  }
  .plat-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;

    .plat-title-info {
      display: flex;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
        margin-right: 8px;
      }

      h1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #000000;
      }
    }
    .plat-title-desc {
      display: flex;
      align-items: center;

      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 28px;
        color: #ff7a3e;
        line-height: 40px;
      }

      img {
        width: 16px;
        height: 30px;
        margin-left: 7px;
      }
    }
  }
  .game-list-card {
    .game-card-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f8f8f8;
      border-radius: 8px;
      border: 2px solid #e6e6e6;
      padding: 20px 20px 20px 50px;
      margin-bottom: 20px;
      position: relative;
      &:last-child {
        margin-bottom: 0;
      }

      .game-plat-left {
        display: flex;
        align-items: center;
      }

      .game-palt {
        text-align: center;
        margin-right: 20px;
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          margin-bottom: 12px;
        }
        span {
          display: block;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 26px;
          color: #000000;
        }
      }
      .game-discount {
        h1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 30px;
          color: #212121;
          line-height: 42px;
          margin-bottom: 12px;
          max-width: 350px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .recharge-discount {
          span {
            width: 150px;
            height: 40px;
            border-radius: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 26px;
            color: #ffffff;
            text-align: center;
            line-height: 40px;
            padding: 1px 15px;

            &:first-child {
              background: #ff7a3e;
              margin-right: 10px;
            }
            &:last-child {
              background: #bbbbbb;
            }
          }
        }
        .recharge-tips {
          span {
            display: inline-block;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 24px;
            color: #ff7a3e;
            text-decoration: underline;
            margin-top: 8px;
          }
        }
      }
      .game-btn {
        width: 120px;
        height: 60px;
        background: #ff7a3e;
        border-radius: 38px;
        text-align: center;
        margin-left: 46px;
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 28px;
          color: #ffffff;
          line-height: 60px;
        }
      }

      .water-mark {
        position: absolute;
        left: 0;
      }
    }

    .tips-10 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 26px;
      color: #ff7a3e;
      line-height: 37px;
    }
  }
  .game-empty {
    width: 690px;
    height: 170px;
    background: #f8f8f8;
    border-radius: 8px;
    border: 2px solid #e6e6e6;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 26px;
    color: #ff0000;
    line-height: 170px;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/GamePlatPopup.vue